import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Icons from "../../assets/icon/index";
export default () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const menuItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      path: "/dashboard",
      icon: Icons.dashboardIcon,
      activeIcon: Icons.dashboardActiveIcon,
    },
    {
      id: "teams",
      label: "Teams",
      path: "/team",
      icon: Icons.TeamIcon,
      activeIcon: Icons.TeamActiveIcon,
    },
    {
      id: "packages",
      label: "Packages",
      path: "/packages",
      icon: Icons.PackagesIcon,
      activeIcon: Icons.PackagesActiveIcon,
    },
    {
      id: "news",
      label: "News",
      path: "/news",
      icon: Icons.NewsIcon,
      activeIcon: Icons.NewsActiveIcon,
    },
    // { id: 'events', label: 'Events', path: '/dashboard-events', icon: Icons.EventIcon, activeIcon: Icons.EventActiveIcon, notification: "15", notificationbgColor: "#37D16F" },
    {
      id: "events",
      label: "Events",
      path: "/event",
      icon: Icons.EventIcon,
      activeIcon: Icons.EventActiveIcon,
    },
    {
      id: "talent",
      label: "Talents",
      path: "/talent",
      icon: Icons.TalentIcon,
      activeIcon: Icons.TalentActiveIcon,
    },
    // { id: 'Project', label: 'Project', path: '', icon: Icons.ProjectIcon, activeIcon: Icons.ProjectActiveIcon, notification: "02", notificationbgColor: "#D750FF" },
    {
      id: "Project",
      label: "Project",
      path: "/project",
      icon: Icons.ProjectIcon,
      activeIcon: Icons.ProjectActiveIcon,
    },
    // { id: 'Messages', label: 'Messages', path: '/chat', icon: Icons.chatmessageIcon, activeIcon: Icons.chatmessageActiveIcon },
    // { id: 'My Gallery', label: 'Gallery', path: '/my-gallery', icon: Icons.galleryMenuIcon, activeIcon: Icons.galleryMenuActiveIcon },
  ];
  // if (userData?.role === 'talent' || userData?.role === 'employer') {
  //     menuItems.push({
  //         id: 'Messages',
  //         label: 'Messages',
  //         path: '/chat',
  //         icon: Icons.chatmessageIcon,
  //         activeIcon: Icons.chatmessageActiveIcon
  //     });
  // }
  // if (userData?.role === 'talent') {
  //     menuItems.push({
  //         id: 'Gallery',
  //         label: 'Gallery',
  //         path: '/my-gallery',
  //         icon: Icons.galleryMenuIcon,
  //         activeIcon: Icons.galleryMenuActiveIcon
  //     });
  // }
  return {
    setIsOpen,
    isOpen,
    menuItems,
    navigate,
    setHoveredItem,
    isActive,
    hoveredItem,
  };
};
